import { Dispatch, SetStateAction } from "react";
import { useIsClient } from "hooks";
import { WpPage, WpPost, WpProject_Gallery } from "codegen";

export const performSearch = (
  searchItems: (WpPost | WpPage | WpProject_Gallery)[],
  setSearchResults: Dispatch<SetStateAction<(WpPage | WpPost | WpProject_Gallery)[]>>,
  searchValue: string,
): void => {
  if (searchValue === "all" || !useIsClient) {
    setSearchResults(searchItems);
    return;
  }

  const searchValueInLowercase = searchValue.toLowerCase();
  const foundItems = searchItems.filter(
    (item) =>
      item.content?.toLowerCase().includes(searchValueInLowercase) ||
      item.title.toLowerCase().includes(searchValueInLowercase) ||
      ("excerpt" in item && item.excerpt.toLowerCase().includes(searchValueInLowercase)) ||
      ("categories" in item &&
        item.categories.nodes.find((category) => category.name?.toLowerCase().includes(searchValueInLowercase))),
  );

  setSearchResults(foundItems);
};
